import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import CustomSelect from "@/components/common/CustomSelect.vue";
import { FormFields } from "@/library/types/structure/formStructure";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SelectFieldType } from "@/library/types/structure/subfieldTypes";
import {
  ref,
  onMounted,
  Ref
} from "vue";

export type SelectOptions = {
  key: string;
  value: string;
};

type SelectFieldProps = {
  selectField: SelectFieldType | null;
  selectFieldValues: FormFields["key"];
  showError?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectField',
  props: {
    selectField: { default: null },
    selectFieldValues: { default: () => ({}) },
    showError: { type: Boolean, default: false }
  },
  emits: ["update:selectFieldValues"],
  setup(__props: any, { emit: __emit }) {

const selectFieldProps = __props;

const emit = __emit;

const localSelectFieldValues: Ref<string | number | null> = ref(null);

const sortedOptions = (fieldChoices: {
  [key: string]: string;
}): SelectOptions[] => {
  const sortedEntries = Object.entries(fieldChoices).sort(([a], [b]) =>
    a.localeCompare(b)
  );
  const sortedArray = sortedEntries.map(([key, value]) => ({ key, value }));
  return sortedArray;
};

onMounted(() => {
  if (selectFieldProps.selectField?.default_value) {
    localSelectFieldValues.value = String(
      selectFieldProps.selectField.default_value
    );

    return;
  }

  if (
    typeof selectFieldProps.selectFieldValues === "string" ||
    typeof selectFieldProps.selectFieldValues === "number"
  ) {
    localSelectFieldValues.value = selectFieldProps.selectFieldValues;
    return;
  }

  localSelectFieldValues.value = null;
  return;
});

return (_ctx: any,_cache: any) => {
  return (__props.selectField)
    ? (_openBlock(), _createBlock(CustomSelect, {
        key: String(localSelectFieldValues.value),
        withComponents: true,
        required: __props.selectField.required === 1 ? true : false,
        id: __props.selectField.key,
        name: __props.selectField.key,
        options: sortedOptions(__props.selectField.choices),
        reducedKey: 'key',
        label: "value",
        placeholder: 
      __props.selectField.placeholder.length
        ? __props.selectField.placeholder
        : __props.selectField.default_value
        ? String(__props.selectField.default_value)
        : __props.selectField.label
        ? __props.selectField.label
        : ''
    ,
        modelValue: localSelectFieldValues.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((localSelectFieldValues).value = $event)),
          _cache[1] || (_cache[1] = (option) => {
      emit('update:selectFieldValues', option)})
        ],
        appendToBody: true,
        clearable: __props.selectField.required === 1 ? false : true,
        showError: __props.showError
      }, null, 8, ["required", "id", "name", "options", "placeholder", "modelValue", "clearable", "showError"]))
    : _createCommentVNode("", true)
}
}

})